import axios from 'axios';
//import config from '../../config';
//import config from '../../config';
import config from '../../config';

export const postNotificationSend = (notificationObj) => {
   const url = `${config.apiUrl}/v1/util/notificationSend`;
   return axios.post(url, notificationObj)
      .then(response => response.data);
}
export const postLogSave = (log) => {
   const url = `${config.apiUrl}/v1/log`;
   return axios.post(url, log)
      .then(response => response.data);
}

export const postOpinionsSave = (Opinions) => {
   const url = `${config.apiUrl}/v1/util/opinionsSave`;
   return axios.post(url, Opinions)
      .then(response => response.data);
}

export const getSMSBalance = () => {
   const url = `${config.apiUrl}/v1/util/getSMSBalance`;
   return axios.get(url)
      .then(response => response.data);
}


export const getOpinionsByInst = (inst) => {
   const url = `${config.apiUrl}/v1/util/opinions/${inst}`;
   return axios.get(url)
      .then(response => response.data);
}

export const getOpinionsIsScienceoardByUserId = (userId) => {
   const url = `${config.apiUrl}/v1/util/opinions/isScienceBoard/${userId}`;
   return axios.get(url)
      .then(response => response.data);
}

export const getAnnouncementList = async () => {
   const url = `${config.apiUrl}/v1/util/announcement/`;
   return axios.get(url)
      .then(response => response.data);
}

export const postAnnouncementSave = async (announcementObj) => {
   const url = `${config.apiUrl}/v1/util/announcement/`;
   return axios.post(url, announcementObj)
      .then(response => response.data);
}

export const putAnnouncementUpdate = async (announcementObj) => {
   const url = `${config.apiUrl}/v1/util/announcement/`;
   return axios.put(url, announcementObj)
      .then(response => response.data);
}

export const deleteAnnouncement = async (announcementObj) => {
   const url = `${config.apiUrl}/v1/util/announcement/`;
   return axios.delete(url, announcementObj)
      .then(response => response.data);
}

export const postUploadAnnouncementFileApi = async (formData, onUploadProgress) => {
   //  //console.log("file upload  çalıştı");
   try {
      const url = `${config.apiUrl}/v1/util/announcement/upload/image/`;
      return await axios.post(url, formData, {
         headers: {
            'Content-Type': 'multipart/form-data'
         },
         onUploadProgress
      }).then(response => response.data)

   } catch (err) {
      if (err.response.status === 500) {
         //console.log("Sunucu problemi var")
         return { status: false, errorMessage: "Sunucu problemi var" }
      }
      else {
         //console.log(err.response.data.msg);
         return { status: false, errorMessage: err.response.data.msg }
      }
   }
}

export const getLanguagesApi = async () => {
   const url = `${config.apiUrl}/v1/util/languages`;
   return axios.get(url)
      .then(response => response.data);
}